import { useLoaderData } from 'react-router-dom';
import { useEffect } from 'react';
import useAuth from '../utils/auth';
import ResourceCard from '../components/home/cardResource';
import ClientLogo from '../components/logoClient';
import PostResourceCards from '../services/adapters/resourceCards';
import SnapshotWardDropdown from '../components/snapshotWardDropdown';
import useSnapshotWardFilters from '../hooks/useSnapshotWardFilters';
import useSnapshot from '../utils/snapshot';
import useRequestState from '../hooks/useRequestState';
import PostImpactCardData from '../services/adapters/impactCard';
import ImpactCard from '../components/home/cardImpact';
import CardContainer from '../components/home/cardContainer';
import { ImpactCardInterface,ResourceCardInterface } from '../types/global';
import SummaryHeadlineCardContainer from '../components/home/summaryHeadlineCardContainer';

export const loader = async () => new PostResourceCards().adaptResponse({ component: 'home' });

export default function Home() {
  const data = useLoaderData<ResourceCardInterface[]>();
  const user = useAuth();
  const { snapshot } = useSnapshot();
  const {
    selectedSnapshot,
    selectedLocalAuthority,
    selectedWard,
    handleSnapshotChange,
    handleLocalAuthorityChange,
    handleWardChange,
  } = useSnapshotWardFilters(snapshot);

  const {
    data: impactCardData,
    error: impactCardError,
    loading: impactCardLoading,
    handleRequest: handleImpactCardRequest,
  } = useRequestState<ImpactCardInterface[]>();

  useEffect(() => {
    const getSummaryCards = async () => {
      const impactAdapter = new PostImpactCardData();
      const impactResponse = impactAdapter.adaptResponse({ snapshot: selectedSnapshot.value, liftDataId: selectedLocalAuthority.value, wardName: selectedWard.value });
      await handleImpactCardRequest(impactResponse);
    };
    void getSummaryCards();
  }, [selectedSnapshot.value, selectedLocalAuthority.value, selectedWard.value]);
  return (
    <div id="dashboard-page" className="flex flex-col w-full gap-2 my-4">
      <header className="mx-4">
        <div className="flex flex-row justify-between items-center">
          <div id="dashboard-header-text" className="flex flex-col">
            <span className="self-stretch justify-start text-secondary text-3xl font-semibold">{`LIFT Summary: ${user.organisationDisplayName}`}</span>
            <span className="text-sm text-secondary">
              {`Welcome back ${user.email}`}
            </span>
          </div>
          <ClientLogo className="w-auto" />
        </div>
        <SnapshotWardDropdown
          selectedSnapshot={selectedSnapshot || { label: snapshot.formattedSnapshot, value: snapshot.rawSnapshot }}
          selectedWard={selectedWard}
          selectedLocalAuthority={selectedLocalAuthority}
          onSnapshotChange={handleSnapshotChange}
          onWardChange={handleWardChange}
          onLocalAuthorityChange={handleLocalAuthorityChange}
        />
      </header>
      <div id="card-container" className="mx-2">
        <div id="headline-cards-container" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full">
          <SummaryHeadlineCardContainer
            snapshot={selectedSnapshot.value}
            liftDataId={selectedLocalAuthority.value}
            wardName={selectedWard.value}
          />
        </div>
        <div id="summary-cards-container" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full">
          <CardContainer
            data={impactCardData}
            error={impactCardError}
            loading={impactCardLoading}
            getKey={(card) => card.title}
            renderItem={(card) => <ImpactCard key={card.title} impactCardData={card} />}
          />
        </div>
        <div id="resource-cards-container" className="flex flex-row flex-wrap w-full justify-start">
          {data.map((card: ResourceCardInterface) => (
            <ResourceCard key={card.title} resourceType={card.category} resource={card.title} redirectUrl={card.url} />
          ))}
        </div>
      </div>
    </div>
  );
}
